(function(){
  // =========================
  // Localization
  // =========================
  const userLang = document.documentElement.lang || 'nl';
  const isEn = userLang.toLowerCase().startsWith('en');

  const T = {
    lblTitle: isEn ? "Prafia Smart Label Crop™" : "Prafia Smart Label Crop™",
    lblSubtitle: isEn 
      ? "Convert A4 shipping labels (e.g. Vinted) directly to print-ready 4×6 (100×150mm)." 
      : "Zet A4-verzendlabels (o.a. Vinted) direct om naar printklaar 4x6 (100×150mm).",
    txtUpload: isEn ? "Upload PDF" : "Upload PDF",
    txtDrag: isEn ? "Click or drag files here" : "Klik of sleep bestanden hier",
    
    // Updated Translations
    btnSmartAll: isEn ? "Smart-Crop™ All" : "Smart-Crop™ Alles",
    lblMoreOpts: isEn ? "More Bulk Options" : "Meer Bulk Opties",
    lblApplyPages: isEn ? "Apply to all pages" : "Pas toe op alle pagina's",
    

// --- Nieuwe vertalingen voor de Chips ---
    f1t: isEn ? "Smart-Crop™:" : "Smart-Crop™:",
    f1d: isEn ? "Removes instruction text" : "Verwijdert instructietekst",
    
    f2t: isEn ? "Auto-Split:" : "Auto-Split:",
    f2d: isEn ? "Cuts 2 or 4 labels" : "Knipt 2 of 4 labels los",
    
    f3t: isEn ? "Print Ready:" : "Print Ready:",
    f3d: isEn ? "Sharp 4x6 labels" : "Scherpe 4x6 labels",


    // Grid buttons
    txtSplit2H: "Split 2 (H)",
    txtSplit2V: "Split 2 (V)",
    txtSplit4: "Split 4",
    txtTop: isEn ? "Top Half" : "Top Helft",
    txtBot: isEn ? "Bottom Half" : "Onder Helft",
    txtFull: isEn ? "Full A4" : "Volledig A4",

    btnDlAll: isEn ? "Download PDF" : "Download PDF",
    
    // Card UI
    btnHeroSmart: isEn ? "✨ Smart-Crop™" : "✨ Smart-Crop™",
    btnHeroSmartApplied: isEn ? "✨ Smart-Crop™ Applied" : "✨ Smart-Crop™ Toegepast",
    lblDrawer: isEn ? "Show manual options" : "Toon handmatige opties",
    btnEdit: isEn ? "Edit" : "Bewerken",
    btnDlLabel: isEn ? "Download Label" : "Download Label",

    // Editor & Other
    lblEdit: isEn ? "Manual Crop" : "Handmatig Bijsnijden",
    lblDraw: isEn ? "New Box" : "Nieuw Kader",
    btnCancel: isEn ? "Cancel" : "Annuleren",
    btnSave: isEn ? "Save" : "Opslaan",
    lblApply: isEn ? "Apply to:" : "Toepassen op:",
    tooltip: isEn
      ? "• Slot = a section of the page after splitting (in 4-split: top-left / top-right / bottom-left / bottom-right).<br>• Same slot = apply to exactly the same slot as this label.<br>• All slots = apply per slot, but keep the crop inside each slot (useful for 2/4-split).<br>• (High) risk = may apply incorrectly for different layouts/files."
      : "• Vak = een deel van de pagina na split (bij 4-split: linksboven/rechtsboven/linksonder/rechtsonder).<br>• Zelfde vak = pas toe op precies datzelfde vak als dit label.<br>• Alle vakken = pas per vak toe, maar houd de crop altijd binnen elk vak (handig bij 2/4-split).<br>• (Hoog) risico = kan verkeerd uitpakken bij andere layouts/bestanden.",
    optSingle: isEn ? "Only this label (default)" : "Alleen dit label (standaard)",
    optFilePos: isEn ? "This file · same slot (recommended)" : "Dit bestand · zelfde vak (aanbevolen)",
    optFileAllPos: isEn ? "This file · all slots (expert)" : "Dit bestand · alle vakken (expert)",
    optPosAllFiles: isEn ? "All files · same slot (risk)" : "Alle bestanden · zelfde vak (risico)",
    optAll: isEn ? "All files · everything (high risk)" : "Alle bestanden · alles (hoog risico)",
    alertNo: isEn ? "No files." : "Geen bestanden.",
    toastApplied: (n) => (isEn ? `Applied to ${n} label(s).` : `Toegepast op ${n} label(s).`),
txtPrivacy: isEn ? "<strong>100% Privacy:</strong> Files are processed locally and never leave your device." : "<strong>100% Privacy:</strong> Bestanden worden lokaal verwerkt en verlaten je apparaat niet."
  };

  const root = document.getElementById('prafia-tool-root');
  root.querySelector('#lbl-title').textContent = T.lblTitle;
  root.querySelector('#lbl-subtitle').textContent = T.lblSubtitle;

// --- Vul de Chip teksten ---
  root.querySelector('#f1-t').textContent = T.f1t; 
  root.querySelector('#f1-d').textContent = T.f1d;
  
  root.querySelector('#f2-t').textContent = T.f2t; 
  root.querySelector('#f2-d').textContent = T.f2d;
  
  root.querySelector('#f3-t').textContent = T.f3t; 
  root.querySelector('#f3-d').textContent = T.f3d;

  root.querySelector('#txt-upload').textContent = T.txtUpload;
  root.querySelector('#txt-drag').textContent = T.txtDrag;
root.querySelector('#txt-privacy').innerHTML = T.txtPrivacy;

  // New UI Text
  root.querySelector('#lbl-smart-all').textContent = T.btnSmartAll;
  root.querySelector('#lbl-more-opts').textContent = T.lblMoreOpts;
  root.querySelector('#lbl-apply-pages').textContent = T.lblApplyPages;
  root.querySelector('#lbl-dl-all').textContent = T.btnDlAll;
  
  // Set Bulk Dropdown Text
  root.querySelectorAll('.bulk-act-split2h').forEach(b => b.lastChild.textContent = " " + T.txtSplit2H);
  root.querySelectorAll('.bulk-act-split2v').forEach(b => b.lastChild.textContent = " " + T.txtSplit2V);
  root.querySelectorAll('.bulk-act-split4').forEach(b => b.lastChild.textContent = " " + T.txtSplit4);
  root.querySelector('.bulk-act-top .txt-top').textContent = T.txtTop;
  root.querySelector('.bulk-act-bot .txt-bot').textContent = T.txtBot;
  root.querySelector('.bulk-act-full .txt-full').textContent = T.txtFull;

  root.querySelector('#lbl-edit').textContent = T.lblEdit;
  root.querySelector('#lbl-draw').textContent = T.lblDraw;
  root.querySelector('#btn-cancel').textContent = T.btnCancel;
  root.querySelector('#btn-save').textContent = T.btnSave;
  root.querySelector('#lbl-apply').textContent = T.lblApply;
  root.querySelector('#plc-tooltip').innerHTML = T.tooltip;

  // Set dropdown option labels (NL/EN)
  (function(){
    const sel = root.querySelector('#editor-apply-mode');
    if(!sel) return;
    const byVal = (v) => sel.querySelector(`option[value="${v}"]`);
    const o1 = byVal('single'); if(o1) o1.textContent = T.optSingle;
    const o2 = byVal('file_pos'); if(o2) o2.textContent = T.optFilePos;
    const o3 = byVal('file_allpos'); if(o3) o3.textContent = T.optFileAllPos;
    const o4 = byVal('pos_allfiles'); if(o4) o4.textContent = T.optPosAllFiles;
    const o5 = byVal('all'); if(o5) o5.textContent = T.optAll;
  })();

  // =========================
  // pdf.js worker
  // =========================
  if (window.pdfjsLib && pdfjsLib.GlobalWorkerOptions) {
    pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js';
  }

  // =========================
  // State
  // =========================
  const grid = root.querySelector('#plc-grid');
  const dropZone = root.querySelector('#plc-drop-zone');
  const fileInput = root.querySelector('#plc-file-input');
  const toastEl = root.querySelector('#plc-toast');

  const store = {};
  const fileOrder = [];
  const fileBytesCache = new Map();
  const pageMetaCache = new Map();

  let currentEditId = null;
  let editScale = 1;
  let isDrawingMode = false;
  let toastTimer = null;

  // =========================
  // Tooltip behavior
  // =========================
  const tipBtn = root.querySelector('#plc-info-btn');
  const tipBox = root.querySelector('#plc-tooltip');
  function showTip(){ tipBox.classList.add('show'); }
  function hideTip(){ tipBox.classList.remove('show'); }
  function toggleTip(e){
    e.preventDefault(); e.stopPropagation();
    if (tipBox.classList.contains('show')) hideTip(); else showTip();
  }
  tipBtn.addEventListener('mouseenter', () => { if (window.innerWidth > 768) showTip(); });
  tipBtn.addEventListener('mouseleave', () => { if (window.innerWidth > 768) hideTip(); });
  tipBtn.addEventListener('click', toggleTip);
  document.addEventListener('click', (e) => {
    if (e.target !== tipBtn && !tipBtn.contains(e.target)) hideTip();
  });

  function showToast(msg){
    toastEl.textContent = msg;
    toastEl.classList.add('show');
    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toastEl.classList.remove('show'), 3000);
  }

// --- NIEUWE FUNCTIE VOOR PRINT ALERT (Aangepaste tekst) ---
  function showPrintToast() {
    // Check de taal (isEn variabele die al in je script zit) om de juiste tekst te tonen
    // Als isEn niet beschikbaar is in deze scope, vallen we terug op NL/EN combinatie
    
    const txt = (typeof isEn !== 'undefined' && isEn) 
      ? "<strong>Note:</strong> Select 'Scale to Fit' / 'Fit to Page'"
      : "<strong>Let op:</strong> Kies 'Scale to Fit' of 'Pas aan'";

    toastEl.innerHTML = `
      <div style="display:flex; align-items:center; gap:10px;">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 9V2h12v7"></path><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"></path><path d="M6 14h12v8H6z"></path></svg>
        <span>${txt}</span>
      </div>
    `;
    
    toastEl.classList.add('print-alert');
    toastEl.classList.add('show');

    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(() => {
      toastEl.classList.remove('show');
      setTimeout(() => { toastEl.classList.remove('print-alert'); }, 300); 
    }, 6000); // Iets langer (6 sec) zodat ze het rustig kunnen lezen
  }


  // =========================
  // Event listeners (Updated for new UI)
  // =========================
  dropZone.addEventListener('click', () => fileInput.click());
  dropZone.addEventListener('dragover', (e) => { e.preventDefault(); dropZone.classList.add('plc-dragover'); });
  dropZone.addEventListener('dragleave', () => dropZone.classList.remove('plc-dragover'));
  dropZone.addEventListener('drop', (e) => {
    e.preventDefault();
    dropZone.classList.remove('plc-dragover');
    handleFiles(e.dataTransfer.files);
  });
  fileInput.addEventListener('change', () => handleFiles(fileInput.files));

  // Bulk Actions
  root.querySelector('#btn-auto').addEventListener('click', () => applyToAll('auto'));
  root.querySelector('.bulk-act-top').addEventListener('click', () => applyToAll('top'));
  root.querySelector('.bulk-act-bot').addEventListener('click', () => applyToAll('bottom'));
  root.querySelector('.bulk-act-full').addEventListener('click', () => applyToAll('full'));
  
  // Bulk Splits need custom logic to loop all files
  root.querySelector('.bulk-act-split2h').addEventListener('click', () => {
     [...fileOrder].forEach(id => forceSplit(id, '2h'));
  });
  root.querySelector('.bulk-act-split2v').addEventListener('click', () => {
     [...fileOrder].forEach(id => forceSplit(id, '2v'));
  });
  root.querySelector('.bulk-act-split4').addEventListener('click', () => {
     [...fileOrder].forEach(id => forceSplit(id, '4'));
  });

  root.querySelector('#btn-dl-all').addEventListener('click', downloadAllVectorPDF);
  root.querySelector('#btn-clear').addEventListener('click', clearAllLabels);

  root.querySelector('#btn-close-editor').addEventListener('click', closeEditor);
  root.querySelector('#btn-cancel').addEventListener('click', closeEditor);
  root.querySelector('#btn-save').addEventListener('click', saveManualCrop);
  root.querySelector('#btnDrawMode').addEventListener('click', toggleDrawMode);

  // Hidden imports/exports
  root.querySelector('#btn-export-json').addEventListener('click', exportDatasetJSON);
  root.querySelector('#btn-import-json').addEventListener('click', () => root.querySelector('#plc-json-input').click());
  root.querySelector('#plc-json-input').addEventListener('change', importDatasetJSON);

  // =========================
  // Main upload handler
  // =========================
  async function handleFiles(files) {
    const list = Array.from(files || []);
    if (!list.length) return;

    try {
      for (const file of list) {
        if (!file || file.type !== 'application/pdf') continue;
        const ab = await file.arrayBuffer();
        const bytes = new Uint8Array(ab);
        const fileKey = `${file.name}::${file.size}::${file.lastModified}`;
        if (!fileBytesCache.has(fileKey)) {
          fileBytesCache.set(fileKey, new Uint8Array(bytes.slice(0)));
        }
        const bytesForViewer = new Uint8Array(bytes.slice(0));
        const loadingTask = pdfjsLib.getDocument({
          data: bytesForViewer,
          disableWorker: false
        });
        const pdf = await loadingTask.promise;
        for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
          const page = await pdf.getPage(pageNum);
          await processPageToLabels(page, file.name, fileKey, pageNum);
        }
      }
      fileInput.value = '';
    } catch (e) {
      console.error(e);
      alert("Error while processing PDF. Check console.");
    }
  }

  // =========================
  // Helpers: ink + components (Original Logic)
  // =========================
  function clamp(v, min, max){ return Math.max(min, Math.min(max, v)); }

  function isInkAt(d, idx){
    const TH = 248; const A_MIN = 12;
    const a = d[idx+3];
    if(a < A_MIN) return false;
    const r=d[idx], g=d[idx+1], b=d[idx+2];
    return (r < TH || g < TH || b < TH);
  }

  function _rectInkCoverage(imgData, W, H, rect, step = 4) {
    const d = imgData.data;
    const x0 = Math.max(0, Math.min(W - 1, Math.floor(rect.x)));
    const y0 = Math.max(0, Math.min(H - 1, Math.floor(rect.y)));
    const x1 = Math.max(0, Math.min(W, Math.ceil(rect.x + rect.w)));
    const y1 = Math.max(0, Math.min(H, Math.ceil(rect.y + rect.h)));
    let ink = 0, tot = 0;
    for (let y = y0; y < y1; y += step) {
      const row = y * W * 4;
      for (let x = x0; x < x1; x += step) {
        const i = row + x * 4;
        tot++;
        if (isInkAt(d, i)) ink++;
      }
    }
    return tot ? (ink / tot) : 0;
  }

  function detectBBoxSimpleRegion(imgData, W, H, region, y0, y1, TH){
    const data = imgData.data;
    const x0 = Math.max(0, Math.min(W, region.x0|0));
    const x1 = Math.max(0, Math.min(W, region.x1|0));
    y0 = Math.max(0, Math.min(H, y0|0));
    y1 = Math.max(0, Math.min(H, y1|0));
    let minX = x1, minY = y1, maxX = -1, maxY = -1;
    for(let y=y0; y<y1; y+=4){
      let row = y * W * 4;
      for(let x=x0; x<x1; x+=4){
        const i = row + x*4;
        if(data[i] < TH || data[i+1] < TH || data[i+2] < TH){
          if(x < minX) minX = x;
          if(y < minY) minY = y;
          if(x > maxX) maxX = x;
          if(y > maxY) maxY = y;
        }
      }
    }
    if(maxX < 0) {
      return {minX: x0, minY: y0, maxX: x1-1, maxY: y1-1};
    }
    return {minX, minY, maxX, maxY};
  }

  function findInkComponentsInRegion(imgData, W, H, region, step = 2){
    const d = imgData.data;
    const x0 = Math.max(0, Math.min(W, region.x0|0));
    const y0 = Math.max(0, Math.min(H, region.y0|0));
    const x1 = Math.max(0, Math.min(W, region.x1|0));
    const y1 = Math.max(0, Math.min(H, region.y1|0));
    const RW = Math.max(1, x1 - x0);
    const RH = Math.max(1, y1 - y0);
    const w = Math.ceil(RW/step);
    const h = Math.ceil(RH/step);
    const mask = new Uint8Array(w*h);
    for(let yy=0; yy<h; yy++){
      const y = y0 + yy*step;
      if(y >= y1) break;
      for(let xx=0; xx<w; xx++){
        const x = x0 + xx*step;
        if(x >= x1) break;
        const idx = (y*W + x)*4;
        if(isInkAt(d, idx)) mask[yy*w+xx]=1;
      }
    }
    const seen = new Uint8Array(w*h);
    const comps = [];
    const qx = new Int32Array(w*h), qy = new Int32Array(w*h);
    for(let yy=0; yy<h; yy++){
      for(let xx=0; xx<w; xx++){
        const idx = yy*w+xx;
        if(!mask[idx] || seen[idx]) continue;
        let head=0, tail=0;
        qx[tail]=xx; qy[tail]=yy; tail++; seen[idx]=1;
        let minX=xx, minY=yy, maxX=xx, maxY=yy, count=0;
        while(head<tail){
          const cx = qx[head], cy = qy[head]; head++; count++;
          if(cx<minX) minX=cx; if(cy<minY) minY=cy;
          if(cx>maxX) maxX=cx; if(cy>maxY) maxY=cy;
          for(let dy=-1; dy<=1; dy++){
            for(let dx=-1; dx<=1; dx++){
              if(!dx && !dy) continue;
              const nx=cx+dx, ny=cy+dy;
              if(nx<0||ny<0||nx>=w||ny>=h) continue;
              const nidx = ny*w+nx;
              if(mask[nidx] && !seen[nidx]){
                seen[nidx]=1;
                qx[tail]=nx; qy[tail]=ny; tail++;
              }
            }
          }
        }
        comps.push({
          minX: x0 + minX*step,
          minY: y0 + minY*step,
          maxX: Math.min(W-1, x0 + maxX*step + (step-1)),
          maxY: Math.min(H-1, y0 + maxY*step + (step-1)),
          count
        });
      }
    }
    return comps;
  }

  function boxesIntersect(a,b){
    const pad = 30;
    const aMinX = a.minX - pad;
    const aMaxX = a.maxX + pad;
    const aMinY = a.minY - pad; const aMaxY = a.maxY + pad;
    return !(aMaxX < b.minX || aMinX > b.maxX || aMaxY < b.minY || aMinY > b.maxY);
  }

  function mergeCloseBoxes(boxes, padPx){
    const out = boxes.map(b=>({...b}));
    function expand(b){ return { minX: b.minX-padPx, minY: b.minY-padPx, maxX: b.maxX+padPx, maxY: b.maxY+padPx }; }
    let changed=true;
    while(changed){
      changed=false;
      for(let i=0;i<out.length;i++){
        for(let j=i+1;j<out.length;j++){
          if(boxesIntersect(expand(out[i]), expand(out[j]))){
            out[i].minX = Math.min(out[i].minX, out[j].minX);
            out[i].minY = Math.min(out[i].minY, out[j].minY);
            out[i].maxX = Math.max(out[i].maxX, out[j].maxX);
            out[i].maxY = Math.max(out[i].maxY, out[j].maxY);
            out[i].count += out[j].count;
            out.splice(j,1); changed=true; j--;
          }
        }
      }
    }
    return out;
  }

  function barcodeLikeScoreForRect(imgData, W, H, rect, step = 3){
    const d = imgData.data;
    const x0 = Math.max(0, Math.min(W-1, Math.floor(rect.x)));
    const y0 = Math.max(0, Math.min(H-1, Math.floor(rect.y)));
    const x1 = Math.max(0, Math.min(W,   Math.ceil(rect.x + rect.w)));
    const y1 = Math.max(0, Math.min(H,   Math.ceil(rect.y + rect.h)));
    const bw = Math.max(1, x1-x0), bh = Math.max(1, y1-y0);
    const cols = Math.max(1, Math.floor(bw/step));
    const rows = Math.max(1, Math.floor(bh/step));
    const vRunThresh = rows * 0.22;
    const hRunThresh = cols * 0.22;
    let vBarCols = 0;
    for(let cx=0; cx<cols; cx++){
      const x = x0 + cx*step;
      let maxRun=0, cur=0;
      for(let ry=0; ry<rows; ry++){
        const y = y0 + ry*step;
        const idx = (y*W + x)*4;
        if(isInkAt(d, idx)){ cur++; if(cur>maxRun) maxRun=cur; } else cur=0;
      }
      if(maxRun >= vRunThresh) vBarCols++;
    }
    let hBarRows = 0;
    for(let ry=0; ry<rows; ry++){
      const y = y0 + ry*step;
      let maxRun=0, cur=0;
      for(let cx=0; cx<cols; cx++){
        const x = x0 + cx*step;
        const idx = (y*W + x)*4;
        if(isInkAt(d, idx)){ cur++; if(cur>maxRun) maxRun=cur; } else cur=0;
      }
      if(maxRun >= hRunThresh) hBarRows++;
    }
    const sV = vBarCols/cols;
    const sH = hBarRows/rows;
    return Math.max(sV, sH);
  }

  function _rectLooksLikeLabel(imgData, W, H, rect, region) {
    const regionW = Math.max(1, region.x1 - region.x0);
    const regionH = Math.max(1, region.y1 - region.y0);
    const regionArea = regionW * regionH;
    const area = rect.w * rect.h;
    const areaRatio = area / regionArea;
    const ar = Math.min(rect.w, rect.h) / Math.max(rect.w, rect.h);
    const cov = _rectInkCoverage(imgData, W, H, rect, 4);
    if (areaRatio < 0.22) return false;
    if (ar < 0.50 || ar > 0.92) return false;
    if (cov < 0.008) return false;
    if ((rect.w / regionW) < 0.45) return false;
    if ((rect.h / regionH) < 0.45) return false;
    return true;
  }

  // =========================
  // Region-aware crop modes
  // =========================
  function pickBestLabelBoxInRegion(boxes, imgData, W, H, region){
    if(!boxes.length) return null;
    const regionW = Math.max(1, region.x1 - region.x0);
    const regionH = Math.max(1, region.y1 - region.y0);
    const regionArea = regionW * regionH;
    const pageArea = W * H;
    const regionFraction = regionArea / pageArea;
    const EXPECTED_AREA = Math.max(0.18, Math.min(0.85, 0.24 / Math.max(0.12, regionFraction)));
    const AREA_TOL = Math.max(0.16, Math.min(0.90, 0.22 / Math.max(0.12, regionFraction)));
    const targetAR = 2/3;
    function metrics(b){
      const bw = (b.maxX - b.minX + 1);
      const bh = (b.maxY - b.minY + 1);
      const area = bw * bh;
      const areaScore = area / regionArea;
      const ar = Math.min(bw, bh) / Math.max(bw, bh);
      const arScore = 1 - Math.min(1, Math.abs(ar - targetAR) / targetAR);
      const density = (b.count || 0) / Math.max(1, area);
      const densityScore = Math.min(1, density * 18);
      const sizeScore = 1 - Math.min(1, Math.abs(areaScore - EXPECTED_AREA) / AREA_TOL);
      const rect = { x: b.minX, y: b.minY, w: (b.maxX-b.minX+1), h: (b.maxY-b.minY+1) };
      const barcodeScore = barcodeLikeScoreForRect(imgData, W, H, rect, 3);
      let score = sizeScore * 0.30 + arScore * 0.22 + densityScore * 0.16 + areaScore * 0.07 + barcodeScore * 0.25;
      if(areaScore > 0.70 && densityScore < 0.14 && barcodeScore < 0.02) score *= 0.35;
      if(areaScore < 0.10 && barcodeScore < 0.02) score *= 0.25;
      return { bw, bh, area, areaScore, arScore, densityScore, sizeScore, barcodeScore, score };
    }
    const scored = boxes
      .map(b => ({ b, m: metrics(b) }))
      .filter(x => x.m.area >= regionArea * 0.02 && x.m.area <= regionArea * 0.98)
      .sort((a,b)=> b.m.score - a.m.score);
    if(!scored.length) return null;
    return scored[0].b;
  }

  function getRectForMode(imgData, W, H, mode, region) {
    const rgn = region || { x0:0, y0:0, x1:W, y1:H };
    const RX0 = rgn.x0, RY0 = rgn.y0, RX1 = rgn.x1, RY1 = rgn.y1;
    const RW = Math.max(1, RX1 - RX0);
    const RH = Math.max(1, RY1 - RY0);
    if (mode === 'full') return {x:RX0, y:RY0, w:RW, h:RH};
    const PAD = 0.02;
    const CUT = 0.50;
    const toRect = (b) => {
      const padX = RW * PAD;
      const padY = RH * PAD;
      const x = clamp(b.minX - padX, RX0, RX1);
      const y = clamp(b.minY - padY, RY0, RY1);
      const w = clamp((b.maxX + padX) - x, 1, RX1 - x);
      const h = clamp((b.maxY + padY) - y, 1, RY1 - y);
      return {x, y, w, h};
    };
    if (mode === 'top') {
      const y0 = RY0;
      const y1 = RY0 + Math.floor(RH * CUT);
      const b = detectBBoxSimpleRegion(imgData, W, H, rgn, y0, y1, 240);
      return toRect(b);
    }
    if (mode === 'bottom') {
      const y0 = RY0 + Math.floor(RH * CUT);
      const y1 = RY1;
      const b = detectBBoxSimpleRegion(imgData, W, H, rgn, y0, y1, 240);
      return toRect(b);
    }
    if (mode === 'auto') {
      const comps = findInkComponentsInRegion(imgData, W, H, rgn, 2);
      const mergePad = Math.max(30, Math.round(Math.min(RW, RH)*0.05));
      const merged = mergeCloseBoxes(comps, mergePad);
      const bbox = pickBestLabelBoxInRegion(merged, imgData, W, H, rgn);
      if (bbox) {
        const pad = Math.max(18, Math.round(Math.min(RW,RH)*0.02));
        const x = Math.max(RX0, bbox.minX - pad);
        const y = Math.max(RY0, bbox.minY - pad);
        const w = Math.min(RX1 - x, (bbox.maxX - bbox.minX) + pad*2);
        const h = Math.min(RY1 - y, (bbox.maxY - bbox.minY) + pad*2);
        return { x, y, w, h };
      }
      return {x:RX0, y:RY0, w:RW, h:RH};
    }
    return {x:RX0, y:RY0, w:RW, h:RH};
  }

  // =========================
  // Similarity (fallback)
  // =========================
  function _regionToTinyGray(imgData, W, H, region, outN=32){
    const d = imgData.data;
    const x0 = Math.max(0, Math.min(W-1, region.x0|0));
    const y0 = Math.max(0, Math.min(H-1, region.y0|0));
    const x1 = Math.max(0, Math.min(W,   region.x1|0));
    const y1 = Math.max(0, Math.min(H,   region.y1|0));
    const rw = Math.max(1, x1-x0), rh = Math.max(1, y1-y0);
    const out = new Float32Array(outN*outN);
    for(let oy=0; oy<outN; oy++){
      const sy = y0 + (oy + 0.5) * (rh/outN);
      const y = Math.max(0, Math.min(H-1, sy|0));
      for(let ox=0; ox<outN; ox++){
        const sx = x0 + (ox + 0.5) * (rw/outN);
        const x = Math.max(0, Math.min(W-1, sx|0));
        const idx = (y*W + x)*4;
        const r = d[idx], g = d[idx+1], b = d[idx+2], a = d[idx+3];
        const gray = a < 8 ? 255 : (0.299*r + 0.587*g + 0.114*b);
        out[oy*outN+ox] = gray;
      }
    }
    return out;
  }

  function _zncc(a,b){
    const n = a.length;
    let ma=0, mb=0;
    for(let i=0;i<n;i++){ ma+=a[i]; mb+=b[i]; }
    ma/=n; mb/=n;
    let num=0, da=0, db=0;
    for(let i=0;i<n;i++){
      const xa = a[i]-ma;
      const xb = b[i]-mb;
      num += xa*xb;
      da += xa*xa;
      db += xb*xb;
    }
    const den = Math.sqrt(da*db) || 1;
    return num/den;
  }

  // =========================
  // Conservative 2-split
  // =========================
  function _buildProjectionProfile(imgData, W, H, axis, step = 6) {
    const d = imgData.data;
    const out = [];
    const mx = Math.round(W * 0.12);
    const my = Math.round(H * 0.12);
    if (axis === 'y') {
      for (let y = 0; y < H; y += step) {
        let c = 0;
        const row = y * W * 4;
        for (let x = mx; x < W - mx; x += step) {
          const i = row + x * 4;
          if (isInkAt(d, i)) c++;
        }
        out.push(c);
      }
    } else {
      for (let x = 0; x < W; x += step) {
        let c = 0;
        for (let y = my; y < H - my; y += step) {
          const i = (y * W + x) * 4;
          if (isInkAt(d, i)) c++;
        }
        out.push(c);
      }
    }
    return out;
  }

  function _smooth1D(arr, win = 3) {
    const out = new Array(arr.length);
    for (let i = 0; i < arr.length; i++) {
      let s = 0, n = 0;
      for (let k = -win; k <= win; k++) {
        const j = i + k;
        if (j < 0 || j >= arr.length) continue;
        s += arr[j]; n++;
      }
      out[i] = n ? (s / n) : arr[i];
    }
    return out;
  }

  function _avgRange(arr, a, b) {
    let s = 0, n = 0;
    for (let i = a; i <= b; i++) { s += arr[i]; n++; }
    return n ? (s / n) : 0;
  }

  function _minIndex(arr, a, b) {
    let mi = a, mv = arr[a];
    for (let i = a + 1; i <= b; i++) {
      if (arr[i] < mv) { mv = arr[i]; mi = i; }
    }
    return mi;
  }

  function detectTwoUpSplit(imgData, W, H) {
    const step = 6;
    const MID_FROM = 0.30, MID_TO = 0.70;
    const BAND = 3;
    const MAX_VALLEY_RATIO = 0.22;
    function attempt(axis) {
      const p0 = _buildProjectionProfile(imgData, W, H, axis, step);
      const p = _smooth1D(p0, 3);
      const n = p.length;
      const a = Math.max(1, Math.min(n - 2, Math.floor(n * MID_FROM)));
      const b = Math.max(a + 1, Math.min(n - 2, Math.floor(n * MID_TO)));
      const cutBin = _minIndex(p, a, b);
      const ba = Math.max(0, cutBin - BAND);
      const bb = Math.min(n - 1, cutBin + BAND);
      const valley = _avgRange(p, ba, bb);
      const avgMid = _avgRange(p, a, b);
      const valleyRatio = avgMid > 0 ? (valley / avgMid) : 1;
      if (valleyRatio > MAX_VALLEY_RATIO) return null;
      const cutPx = cutBin * step;
      if (axis === 'y') {
        if (cutPx < H * 0.24 || cutPx > H * 0.76) return null;
      } else {
        if (cutPx < W * 0.24 || cutPx > W * 0.76) return null;
      }
      const conf = (1 - valleyRatio);
      return { axis, cutPx, valleyRatio, conf };
    }
    const cy = attempt('y');
    const cx = attempt('x');
    if (!cy && !cx) return null;
    if (cy && !cx) return { axis: 'y', cutPx: cy.cutPx, valleyRatio: cy.valleyRatio };
    if (!cy && cx) return { axis: 'x', cutPx: cx.cutPx, valleyRatio: cx.valleyRatio };
    const best = (cy.conf >= cx.conf) ? cy : cx;
    return { axis: best.axis, cutPx: best.cutPx, valleyRatio: best.valleyRatio };
  }

  // =========================
  // pdf.js text extraction
  // =========================
  async function getTextItemsPx(page, viewport, W, H){
    try {
      const tc = await page.getTextContent({ includeMarkedContent: false });
      const items = tc.items || [];
      const out = [];
      for (const it of items) {
        const str = (it.str || "").trim();
        if (!str) continue;
        const tx = pdfjsLib.Util.transform(viewport.transform, it.transform);
        const x = tx[4];
        const y = tx[5];
        const w = Math.abs(it.width * viewport.scale);
        const h = Math.abs(it.height * viewport.scale) || 10;
        out.push({
          str,
          x, y, w, h,
          nx: W ? x / W : 0,
          ny: H ? y / H : 0,
          nw: W ? w / W : 0,
          nh: H ? h / H : 0,
          fontName: it.fontName || null,
          dir: it.dir || null
        });
      }
      return out;
    } catch(e){
      console.warn("getTextItemsPx failed:", e);
      return [];
    }
  }

  // =========================
  // FIX: strong 4-up detection
  // =========================
  function _cleanTokens(str){
    const s = (str || "").replace(/[^\p{L}\p{N}]+/gu, " ").trim();
    if(!s) return [];
    const parts = s.split(/\s+/);
    const out = [];
    for(const p of parts){
      if(p.length < 3) continue;
      if(/^\d+$/u.test(p)) continue;
      const t = p.replace(/\d+/g, "").trim();
      if(t.length < 3) continue;
      out.push(t.toUpperCase());
    }
    return out;
  }

  function detectFourUpByText(textItemsPx, W, H){
    if(!textItemsPx || textItemsPx.length < 30) return { pass:false, reason:"few_text" };
    const cx = W * 0.5, cy = H * 0.5;
    const quad = [
      { x0:0,  y0:0,  x1:cx, y1:cy },
      { x0:cx, y0:0,  x1:W,  y1:cy },
      { x0:0,  y0:cy, x1:cx, y1:H  },
      { x0:cx, y0:cy, x1:W,  y1:H  }
    ];
    const counts = [0,0,0,0];
    const b = [
      {minX:1e9,minY:1e9,maxX:-1,maxY:-1},
      {minX:1e9,minY:1e9,maxX:-1,maxY:-1},
      {minX:1e9,minY:1e9,maxX:-1,maxY:-1},
      {minX:1e9,minY:1e9,maxX:-1,maxY:-1},
    ];
    const tokenSets = [new Set(), new Set(), new Set(), new Set()];
    for(const it of textItemsPx){
      const x = it.x, y = it.y;
      let q = 0;
      if(x >= cx) q += 1;
      if(y >= cy) q += 2;
      counts[q]++;
      b[q].minX = Math.min(b[q].minX, x);
      b[q].minY = Math.min(b[q].minY, y);
      b[q].maxX = Math.max(b[q].maxX, x + (it.w||0));
      b[q].maxY = Math.max(b[q].maxY, y + (it.h||0));
      const toks = _cleanTokens(it.str);
      for(const t of toks) tokenSets[q].add(t);
    }
    const minC = Math.min(...counts);
    const maxC = Math.max(...counts);
    if(minC < 10) return { pass:false, reason:"min_quad_text_low", counts };
    const balance = maxC ? (minC / maxC) : 0;
    if(balance < 0.55) return { pass:false, reason:"quad_text_unbalanced", counts, balance };
    const coverW = [];
    const coverH = [];
    for(let i=0;i<4;i++){
      if(b[i].maxX < 0) return { pass:false, reason:"missing_quad_bbox", counts };
      const quadW = Math.max(1, quad[i].x1 - quad[i].x0);
      const quadH = Math.max(1, quad[i].y1 - quad[i].y0);
      const bw = Math.max(0, b[i].maxX - b[i].minX);
      const bh = Math.max(0, b[i].maxY - b[i].minY);
      coverW.push(bw / quadW);
      coverH.push(bh / quadH);
    }
    const minCovW = Math.min(...coverW);
    const minCovH = Math.min(...coverH);
    if(minCovW < 0.55 || minCovH < 0.55){
      return { pass:false, reason:"quad_bbox_small", counts, balance, minCovW, minCovH, coverW, coverH };
    }
    let intersection = null;
    for(let i=0;i<4;i++){
      const s = tokenSets[i];
      if(!intersection){
        intersection = new Set(s);
      } else {
        const next = new Set();
        for(const t of intersection){
          if(s.has(t)) next.add(t);
        }
        intersection = next;
      }
    }
    const interSize = intersection ? intersection.size : 0;
    if(interSize < 6){
      return { pass:false, reason:"low_token_intersection", counts, balance, minCovW, minCovH, interSize };
    }
    return {
      pass:true,
      reason:"text_fourup",
      counts, balance, minCovW, minCovH, interSize
    };
  }

  // =========================
  // Strict split decision
  // =========================
  function decideSplitMode(imgData, W, H, textItemsPx){
    const whole = { x0:0, y0:0, x1:W, y1:H };
    const textFour = detectFourUpByText(textItemsPx, W, H);
    if(textFour.pass){
      const cx = Math.round(W * 0.5);
      const cy = Math.round(H * 0.5);
      const quads = [
        { x0:0,  y0:0,  x1:cx, y1:cy },
        { x0:cx, y0:0,  x1:W,  y1:cy },
        { x0:0,  y0:cy, x1:cx, y1:H  },
        { x0:cx, y0:cy, x1:W,  y1:H  }
      ];
      return { mode:'split4', regions: quads, debug: { via:"text", textFour } };
    }
    const cx = Math.round(W * 0.5);
    const cy = Math.round(H * 0.5);
    const quads = [
      { x0:0,  y0:0,  x1:cx, y1:cy },
      { x0:cx, y0:0,  x1:W,  y1:cy },
      { x0:0,  y0:cy, x1:cx, y1:H  },
      { x0:cx, y0:cy, x1:W,  y1:H  }
    ];
    const quadRects = quads.map(r => getRectForMode(imgData, W, H, 'auto', r));
    const quadOk = quadRects.map((rect,i) => _rectLooksLikeLabel(imgData, W, H, rect, quads[i]));
    const quadBarcode = quadRects.map(rect => barcodeLikeScoreForRect(imgData, W, H, rect, 3));
    const barcodePassCount = quadBarcode.filter(s => s >= 0.10).length;
    const tiny = quads.map(r => _regionToTinyGray(imgData, W, H, r, 32));
    const pairs = [
      _zncc(tiny[0], tiny[1]),
      _zncc(tiny[0], tiny[2]),
      _zncc(tiny[1], tiny[3]),
      _zncc(tiny[2], tiny[3]),
      _zncc(tiny[0], tiny[3]),
      _zncc(tiny[1], tiny[2]),
    ];
    const simAvg = pairs.reduce((a,b)=>a+b,0) / pairs.length;
    const okCount = quadOk.filter(Boolean).length;
    const fourSplit =
      okCount >= 3 &&
      barcodePassCount >= 3 &&
      simAvg >= 0.72;
    if (fourSplit) {
      return { mode: 'split4', regions: quads, debug: { via:"image", okCount, barcodePassCount, simAvg, quadBarcode } };
    }
    const split2 = detectTwoUpSplit(imgData, W, H);
    if (split2) {
      const cut = split2.cutPx;
      const regions = (split2.axis === 'y')
        ? [ { x0:0, y0:0, x1:W, y1:cut }, { x0:0, y0:cut, x1:W, y1:H } ]
        : [ { x0:0, y0:0, x1:cut, y1:H }, { x0:cut, y0:0, x1:W, y1:H } ];
      const r1 = getRectForMode(imgData, W, H, 'auto', regions[0]);
      const r2 = getRectForMode(imgData, W, H, 'auto', regions[1]);
      const ok1 = _rectLooksLikeLabel(imgData, W, H, r1, regions[0]);
      const ok2 = _rectLooksLikeLabel(imgData, W, H, r2, regions[1]);
      const a1 = r1.w * r1.h, a2 = r2.w * r2.h;
      const diff = Math.abs(a1 - a2) / Math.max(a1, a2);
      if (ok1 && ok2 && diff <= 0.42) {
        return { mode: 'split2', regions, debug: { via:"projection", axis: split2.axis, cut, valleyRatio: split2.valleyRatio, diff } };
      }
    }
    return { mode: 'single', regions: [whole], debug: { via:"single" } };
  }

  // =========================
  // Render + create cards
  // =========================
  async function processPageToLabels(page, fileName, fileKey, pageNum) {
    const detectScale = 2.0;
    const viewport = page.getViewport({ scale: detectScale });
    const canvas = document.createElement('canvas');
    canvas.width = Math.ceil(viewport.width);
    canvas.height = Math.ceil(viewport.height);
    const ctx = canvas.getContext('2d', { willReadFrequently: true });
    await page.render({ canvasContext: ctx, viewport }).promise;
    const imgData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    const W = canvas.width, H = canvas.height;
    const pageKey = `${fileKey}::page:${pageNum}`;
    let textItemsPx = [];
    if (!pageMetaCache.has(pageKey)) {
      textItemsPx = await getTextItemsPx(page, viewport, W, H);
      pageMetaCache.set(pageKey, {
        fileKey, fileName, pageNum, detectScale,
        renderW: W, renderH: H,
        textItemsPx
      });
    } else {
      textItemsPx = (pageMetaCache.get(pageKey) || {}).textItemsPx || [];
    }
    const decision = decideSplitMode(imgData, W, H, textItemsPx);
    const regions = decision.regions;
    const labelTotal = regions.length;
    for (let i=0; i<labelTotal; i++) {
      const region = regions[i];
      const id = Math.random().toString(36).substr(2, 9);
      const defaultMode = 'auto';
      const rect = getRectForMode(imgData, W, H, defaultMode, region);
      store[id] = {
        canvas, imgData, w:W, h:H,
        viewport, detectScale,
        fileName, fileKey, pageNum, pageKey,
        baseRegion: region,
        currentRect: rect,
        mode: defaultMode,
        labelIndex: i + 1,
        labelTotal,
        splitMode: decision.mode,
        splitDebug: decision.debug || {},
        forcedSplit: false,
        forcedSplitMode: null,
        manualEdited: false
      };
      fileOrder.push(id);
      renderCardForId(id);
    }
  }

  // --- UPDATED RENDER CARD FUNCTION FOR NEW UX ---
  function renderCardForId(id) {
    const d = store[id];
    if (!d) return;
    const card = document.createElement('div');
    card.className = 'plc-card';
    card.id = `plc-card-${id}`;
    const meta = (d.labelTotal > 1)
      ? `Page ${d.pageNum} · Label ${d.labelIndex}/${d.labelTotal}`
      : `Page ${d.pageNum}`;
    
    // Active helpers
    const isActive = (m) => (m === (d.mode || 'auto') ? 'active' : '');
    const smartActive = d.mode === 'auto' ? 'active' : '';
    const smartText = d.mode === 'auto' ? T.btnHeroSmartApplied : T.btnHeroSmart;

    card.innerHTML = `
      <div class="plc-card-header">
        <div>
          <div class="plc-filename" title="${d.fileName}">${d.fileName}</div>
          <div class="plc-file-meta">${meta}</div>
        </div>
        <button class="plc-delete-btn" data-id="${id}" type="button">×</button>
      </div>

      <div class="plc-canvas-box" id="view-${id}"></div>

      <div class="plc-card-controls">
        <button class="btn-hero-smart ${smartActive}" data-id="${id}" data-mode="auto" type="button">
           ${smartText}
        </button>

        <div class="drawer-wrapper">
            <div class="drawer-trigger">
                ${T.lblDrawer} <span>⌄</span>
            </div>
            <div class="drawer-content">
                <div class="panel-grid">
                    <button class="btn-advanced btn-split2h" data-id="${id}" type="button"><div class="ico-base ico-split-h"></div> ${T.txtSplit2H}</button>
                    <button class="btn-advanced btn-split2v" data-id="${id}" type="button"><div class="ico-base ico-split-v"></div> ${T.txtSplit2V}</button>
                    <button class="btn-advanced btn-split4" data-id="${id}" type="button"><div class="ico-base ico-split-4"><div></div><div></div><div></div><div></div></div> ${T.txtSplit4}</button>
                    
                    <button class="btn-advanced ${isActive('top')}" data-id="${id}" data-mode="top" type="button"><div class="ico-base ico-top"></div> ${T.txtTop}</button>
                    <button class="btn-advanced ${isActive('bottom')}" data-id="${id}" data-mode="bottom" type="button"><div class="ico-base ico-bottom"></div> ${T.txtBot}</button>
                    <button class="btn-advanced ${isActive('full')}" data-id="${id}" data-mode="full" type="button"><div class="ico-base ico-full"></div> ${T.txtFull}</button>
                </div>
            </div>
        </div>

        <div class="plc-bottom-actions">
            <button class="plc-btn-action btn-edit" data-id="${id}" type="button">${T.btnEdit}</button>
            <button class="plc-btn-action btn-download" data-id="${id}" type="button">${T.btnDlLabel}</button>
        </div>
      </div>
    `;

    // Wiring events
    card.querySelector('.plc-delete-btn').onclick = () => removeLabel(id);
    
    // Smart Crop
    card.querySelector('.btn-hero-smart').onclick = () => updateSingle(id, 'auto');

    // Drawer Grid Buttons (Modes)
    card.querySelectorAll('.btn-advanced[data-mode]').forEach(b => {
        b.onclick = () => updateSingle(id, b.dataset.mode);
    });
    
    // Drawer Grid Buttons (Splits)
    card.querySelector('.btn-split2h').onclick = () => forceSplit(id, '2h');
    card.querySelector('.btn-split2v').onclick = () => forceSplit(id, '2v');
    card.querySelector('.btn-split4').onclick = () => forceSplit(id, '4');

    // Bottom Actions
    card.querySelector('.btn-edit').onclick = () => openEditor(id);
    card.querySelector('.btn-download').onclick = () => downloadOneVectorPDF(id);

    grid.appendChild(card);
    renderResult(id);
  }

  function updateSingle(id, mode) {
    const data = store[id];
    if (!data) return;

    data.mode = mode;
    data.currentRect = getRectForMode(data.imgData, data.w, data.h, mode, data.baseRegion);

    // Re-render UI state (Smart button vs Advanced button)
    const card = document.getElementById(`plc-card-${id}`);
    if (card) {
        // Handle Smart Button
        const heroBtn = card.querySelector('.btn-hero-smart');
        if(mode === 'auto') {
            heroBtn.classList.add('active');
            heroBtn.innerHTML = T.btnHeroSmartApplied;
        } else {
            heroBtn.classList.remove('active');
            heroBtn.innerHTML = T.btnHeroSmart;
        }

        // Handle Advanced Buttons
        card.querySelectorAll('.btn-advanced[data-mode]').forEach(b => {
            if(b.dataset.mode === mode) b.classList.add('active');
            else b.classList.remove('active');
        });
    }

    renderResult(id);
  }

  function applyToAll(mode) { for (const id of fileOrder) updateSingle(id, mode); }

  function renderResult(id) {
    const data = store[id];
    if (!data) return;
    const { canvas, currentRect } = data;
    const tCan = document.createElement('canvas');
    const tCtx = tCan.getContext('2d');
    const isLand = currentRect.w > (currentRect.h * 1.1);
    if (isLand) {
      tCan.width = Math.max(1, Math.floor(currentRect.h));
      tCan.height = Math.max(1, Math.floor(currentRect.w));
      tCtx.translate(0, currentRect.w);
      tCtx.rotate(-90 * Math.PI / 180);
      tCtx.drawImage(
        canvas,
        currentRect.x, currentRect.y, currentRect.w, currentRect.h,
        0, 0, currentRect.w, currentRect.h
      );
    } else {
      tCan.width = Math.max(1, Math.floor(currentRect.w));
      tCan.height = Math.max(1, Math.floor(currentRect.h));
      tCtx.drawImage(
        canvas,
        currentRect.x, currentRect.y, currentRect.w, currentRect.h,
        0, 0, currentRect.w, currentRect.h
      );
    }
    const viewImg = new Image();
    viewImg.src = tCan.toDataURL('image/jpeg', 0.82);
    const box = document.getElementById(`view-${id}`);
    if (box) {
      box.innerHTML = '';
      box.appendChild(viewImg);
    }
  }

  // =========================
  // Vector export (pdf-lib)
  // =========================
  async function createVectorDoc(idList) {
    const { PDFDocument, degrees } = PDFLib;
    const mergedDoc = await PDFDocument.create();
    const srcDocCache = new Map();
    for (const id of idList) {
      const data = store[id];
      if (!data) continue;
      const bytes = fileBytesCache.get(data.fileKey);
      if (!bytes) throw new Error("Missing file bytes in cache.");
      let srcDoc = srcDocCache.get(data.fileKey);
      if (!srcDoc) {
        const b2 = new Uint8Array(bytes.length);
        b2.set(bytes);
        srcDoc = await PDFDocument.load(b2);
        srcDocCache.set(data.fileKey, srcDoc);
      }
      const [copiedPage] = await mergedDoc.copyPages(srcDoc, [data.pageNum - 1]);
      const rect = data.currentRect;
      const view = data.viewport;
      const [x1, y1] = view.convertToPdfPoint(rect.x, rect.y);
      const [x2, y2] = view.convertToPdfPoint(rect.x + rect.w, rect.y + rect.h);
      const cropX = Math.min(x1, x2);
      const cropY = Math.min(y1, y2);
      const cropW = Math.abs(x1 - x2);
      const cropH = Math.abs(y1 - y2);
      copiedPage.setCropBox(cropX, cropY, cropW, cropH);
      copiedPage.setMediaBox(cropX, cropY, cropW, cropH);
      if (rect.w > rect.h) {
        const currentRot = copiedPage.getRotation().angle;
        copiedPage.setRotation(degrees((currentRot + 90) % 360));
      }
      mergedDoc.addPage(copiedPage);
    }
    return await mergedDoc.save();
  }

  async function downloadOneVectorPDF(id) {
    const pdfBytes = await createVectorDoc([id]);
    const blob = new Blob([pdfBytes], { type: "application/pdf" });
    saveAs(blob, `Label_${store[id].fileName.replace(/\.pdf$/i,'')}_p${store[id].pageNum}_l${store[id].labelIndex}.pdf`);
    showPrintToast();
  }

  async function downloadAllVectorPDF() {
    if (fileOrder.length === 0) return alert(T.alertNo);
    const pdfBytes = await createVectorDoc(fileOrder);
    const blob = new Blob([pdfBytes], { type: "application/pdf" });
    saveAs(blob, "Labels_Prafia.pdf");
    showPrintToast();
  }

  function removeLabel(id) {
    const card = document.getElementById(`plc-card-${id}`);
    if(card) card.remove();
    delete store[id];
    const idx = fileOrder.indexOf(id);
    if(idx > -1) fileOrder.splice(idx, 1);
  }

  function clearAllLabels() {
    grid.innerHTML = '';
    for(const k in store) delete store[k];
    fileOrder.length = 0;
    pageMetaCache.clear();
    fileBytesCache.clear();
  }

  // =========================
  // Manual editor
  // =========================
  function openEditor(id) {
    currentEditId = id;
    const data = store[id];
    const modal = root.querySelector('#plc-editor-modal');
    const img = root.querySelector('#plc-crop-img');
    const rectDiv = root.querySelector('#plc-crop-rect');
    root.querySelector('#editor-apply-mode').value = 'single';
    isDrawingMode = false;
    root.querySelector('#btnDrawMode').classList.remove('active');
    rectDiv.style.display = 'block';
    modal.style.display = 'flex';
    img.src = data.canvas.toDataURL();
    img.onload = () => {
      const displayW = img.getBoundingClientRect().width;
      editScale = displayW / data.w;
      const r = data.currentRect;
      rectDiv.style.left = (r.x * editScale) + 'px';
      rectDiv.style.top = (r.y * editScale) + 'px';
      rectDiv.style.width = (r.w * editScale) + 'px';
      rectDiv.style.height = (r.h * editScale) + 'px';
      initInteract();
    };
  }

  function closeEditor() { root.querySelector('#plc-editor-modal').style.display = 'none'; }

  function toggleDrawMode() {
    isDrawingMode = !isDrawingMode;
    const btn = root.querySelector('#btnDrawMode');
    const rect = root.querySelector('#plc-crop-rect');
    if (isDrawingMode) {
      btn.classList.add('active');
      rect.style.display = 'none';
    } else {
      btn.classList.remove('active');
      rect.style.display = 'block';
    }
  }

  // =========================
  // APPLY LOGIC
  // =========================
  function _normRectInPage(absRect, W, H){
    const x = clamp(absRect.x, 0, Math.max(0, W-1));
    const y = clamp(absRect.y, 0, Math.max(0, H-1));
    const w = clamp(absRect.w, 1, Math.max(1, W - x));
    const h = clamp(absRect.h, 1, Math.max(1, H - y));
    return { nx: x / W, ny: y / H, nw: w / W, nh: h / H };
  }

  function _rectFromNormInPage(nr, W, H){
    let x = nr.nx * W;
    let y = nr.ny * H;
    let w = nr.nw * W;
    let h = nr.nh * H;
    x = clamp(x, 0, Math.max(0, W-1));
    y = clamp(y, 0, Math.max(0, H-1));
    w = clamp(w, 1, Math.max(1, W - x));
    h = clamp(h, 1, Math.max(1, H - y));
    return { x, y, w, h };
  }

  function _normRectInSlot(absRect, region){
    const rx0 = region.x0, ry0 = region.y0;
    const rw = Math.max(1, region.x1 - region.x0);
    const rh = Math.max(1, region.y1 - region.y0);
    let nx = (absRect.x - rx0) / rw;
    let ny = (absRect.y - ry0) / rh;
    let nw = absRect.w / rw;
    let nh = absRect.h / rh;
    nx = clamp(nx, 0, 1);
    ny = clamp(ny, 0, 1);
    nw = clamp(nw, 0.001, 1);
    nh = clamp(nh, 0.001, 1);
    if (nx + nw > 1) nw = Math.max(0.001, 1 - nx);
    if (ny + nh > 1) nh = Math.max(0.001, 1 - ny);
    return { nx, ny, nw, nh };
  }

  function _rectFromNormInSlot(nr, region){
    const rx0 = region.x0, ry0 = region.y0;
    const rw = Math.max(1, region.x1 - region.x0);
    const rh = Math.max(1, region.y1 - region.y0);
    let x = rx0 + nr.nx * rw;
    let y = ry0 + nr.ny * rh;
    let w = nr.nw * rw;
    let h = nr.nh * rh;
    x = clamp(x, region.x0, Math.max(region.x0, region.x1 - 1));
    y = clamp(y, region.y0, Math.max(region.y0, region.y1 - 1));
    w = clamp(w, 1, Math.max(1, region.x1 - x));
    h = clamp(h, 1, Math.max(1, region.y1 - y));
    if (x + w > region.x1) w = Math.max(1, region.x1 - x);
    if (y + h > region.y1) h = Math.max(1, region.y1 - y);
    return { x, y, w, h };
  }

function saveManualCrop() {
    const data = store[currentEditId];
    if (!data) return;

    const rectDiv = root.querySelector('#plc-crop-rect');
    const wrapper = root.querySelector('#plc-crop-wrapper');
    const wRect = wrapper.getBoundingClientRect();
    const rRect = rectDiv.getBoundingClientRect();

    const left = rRect.left - wRect.left;
    const top  = rRect.top  - wRect.top;
    const width  = rRect.width;
    const height = rRect.height;

    let newAbsRect = {
      x: left / editScale,
      y: top / editScale,
      w: width / editScale,
      h: height / editScale
    };

    newAbsRect.x = clamp(newAbsRect.x, 0, Math.max(0, data.w - 1));
    newAbsRect.y = clamp(newAbsRect.y, 0, Math.max(0, data.h - 1));
    newAbsRect.w = clamp(newAbsRect.w, 1, Math.max(1, data.w - newAbsRect.x));
    newAbsRect.h = clamp(newAbsRect.h, 1, Math.max(1, data.h - newAbsRect.y));

    const applyMode = root.querySelector('#editor-apply-mode')?.value || 'single';
    const normPage = _normRectInPage(newAbsRect, data.w, data.h);
    const normSlot = _normRectInSlot(newAbsRect, data.baseRegion);

    let applied = 0;

    for (const id of fileOrder) {
      const cand = store[id];
      if (!cand) continue;

      let match = false;
      if (applyMode === 'single') {
        match = (id === currentEditId);
      } else if (applyMode === 'file_pos') {
        match = (cand.fileKey === data.fileKey &&
                 cand.labelIndex === data.labelIndex &&
                 cand.labelTotal === data.labelTotal);
      } else if (applyMode === 'file_allpos') {
        match = (cand.fileKey === data.fileKey &&
                 cand.labelTotal === data.labelTotal);
      } else if (applyMode === 'pos_allfiles') {
        match = (cand.labelIndex === data.labelIndex &&
                 cand.labelTotal === data.labelTotal);
      } else if (applyMode === 'all') {
        match = true;
      }

      if (!match) continue;

      const slotSafe = (applyMode === 'file_allpos' || applyMode === 'all');
      cand.currentRect = slotSafe
        ? _rectFromNormInSlot(normSlot, cand.baseRegion)
        : _rectFromNormInPage(normPage, cand.w, cand.h);

      // Status updaten naar 'manual'
      cand.mode = 'manual';
      cand.manualEdited = true;

      // --- NIEUWE UI UPDATE LOGICA ---
      const card = document.getElementById(`plc-card-${id}`);
      if (card) {
        // 1. Reset de Smart Crop Hero knop (grijs maken + tekst resetten)
        const heroBtn = card.querySelector('.btn-hero-smart');
        if (heroBtn) {
           heroBtn.classList.remove('active');
           heroBtn.innerHTML = T.btnHeroSmart; // Terug naar "✨ Smart Crop"
        }

        // 2. Reset eventuele actieve Advanced knoppen in de drawer
        card.querySelectorAll('.btn-advanced').forEach(b => {
           b.classList.remove('active');
        });
      }
      // -------------------------------

      renderResult(id);
      applied++;
    }

    closeEditor();
    showToast(T.toastApplied(applied));
  }

  function initInteract() {
    const rectDiv = root.querySelector('#plc-crop-rect');
    const wrapper = root.querySelector('#plc-crop-wrapper');
    let isDragging = false, isResizing = false, isDrawing = false;
    let handle = null, startX, startY, startLeft, startTop, startW, startH;
    const getXY = (e) => {
      const ev = e.touches ? e.touches[0] : e;
      return { x: ev.clientX, y: ev.clientY };
    };
    const startHandlerRect = (e) => {
      if(isDrawingMode) return;
      const target = e.target;
      if(target.classList.contains('plc-handle')) { isResizing = true; handle = target.dataset.dir; }
      else { isDragging = true; }
      const xy = getXY(e); startX = xy.x; startY = xy.y;
      startLeft = rectDiv.offsetLeft;
      startTop = rectDiv.offsetTop;
      startW = rectDiv.offsetWidth; startH = rectDiv.offsetHeight;
      e.preventDefault(); e.stopPropagation();
    };
    const startHandlerWrap = (e) => {
      if (!isDrawingMode) return;
      if (e.target.closest('#plc-crop-rect')) return;
      isDrawing = true;
      const b = wrapper.getBoundingClientRect();
      const xy = getXY(e);
      startX = xy.x - b.left; startY = xy.y - b.top;
      rectDiv.style.display = 'block';
      rectDiv.style.left = startX + 'px';
      rectDiv.style.top = startY + 'px';
      rectDiv.style.width = '0px';
      rectDiv.style.height = '0px';
      e.preventDefault();
    };
    const moveHandler = (e) => {
      if (!isDragging && !isResizing && !isDrawing) return;
      const xy = getXY(e);
      if (isDragging) {
        rectDiv.style.left = (startLeft + xy.x - startX) + 'px';
        rectDiv.style.top  = (startTop  + xy.y - startY) + 'px';
      } else if (isResizing) {
        const dx = xy.x - startX;
        const dy = xy.y - startY;
        if (handle.includes('e')) rectDiv.style.width  = Math.max(20, startW + dx) + 'px';
        if (handle.includes('s')) rectDiv.style.height = Math.max(20, startH + dy) + 'px';
        if (handle.includes('w')) {
          const newW = Math.max(20, startW - dx);
          rectDiv.style.width = newW + 'px';
          rectDiv.style.left  = (startLeft + (startW - newW)) + 'px';
        }
        if (handle.includes('n')) {
          const newH = Math.max(20, startH - dy);
          rectDiv.style.height = newH + 'px';
          rectDiv.style.top    = (startTop + (startH - newH)) + 'px';
        }
      } else if (isDrawing) {
        const b = wrapper.getBoundingClientRect();
        const currX = xy.x - b.left; const currY = xy.y - b.top;
        const w = currX - startX;
        const h = currY - startY;
        rectDiv.style.width  = Math.abs(w) + 'px';
        rectDiv.style.height = Math.abs(h) + 'px';
        rectDiv.style.left   = (w < 0 ? currX : startX) + 'px';
        rectDiv.style.top    = (h < 0 ? currY : startY) + 'px';
      }
      e.preventDefault();
    };
    const endHandler = () => {
      if(isDrawing) { isDrawing = false; toggleDrawMode(); }
      isDragging = false; isResizing = false;
    };
    rectDiv.onmousedown = startHandlerRect;
    rectDiv.ontouchstart = startHandlerRect;
    wrapper.onmousedown = startHandlerWrap;
    wrapper.ontouchstart = startHandlerWrap;
    document.onmousemove = moveHandler;
    document.ontouchmove = moveHandler;
    document.onmouseup = endHandler;
    document.ontouchend = endHandler;
  }

  // =========================
  // FORCE SPLIT (manual)
  // =========================
  function forceSplit(id, mode) {
    const d = store[id];
    if (!d) return;
    if ((d.labelTotal || 1) > 1) {
      // alert only if single mode, but bulk might trigger this so silent fail or log
      // Let's just return to avoid breaking things
      return;
    }
    const W = d.w, H = d.h;
    let regions = [];
    if (mode === '2h') {
      const cut = Math.round(H * 0.5);
      regions = [ { x0:0, y0:0, x1:W, y1:cut }, { x0:0, y0:cut, x1:W, y1:H } ];
    } else if (mode === '2v') {
      const cut = Math.round(W * 0.5);
      regions = [ { x0:0, y0:0, x1:cut, y1:H }, { x0:cut, y0:0, x1:W, y1:H } ];
    } else if (mode === '4') {
      const cx = Math.round(W * 0.5);
      const cy = Math.round(H * 0.5);
      regions = [
        { x0:0,  y0:0,  x1:cx, y1:cy }, { x0:cx, y0:0,  x1:W,  y1:cy },
        { x0:0,  y0:cy, x1:cx, y1:H  }, { x0:cx, y0:cy, x1:W,  y1:H  },
      ];
    } else {
      return;
    }
    removeLabel(id);
    const total = regions.length;
    for (let i=0; i<regions.length; i++) {
      const region = regions[i];
      const newId = Math.random().toString(36).substr(2, 9);
      const rect = getRectForMode(d.imgData, W, H, 'auto', region);
      store[newId] = {
        canvas: d.canvas,
        imgData: d.imgData,
        w: W, h: H,
        viewport: d.viewport,
        detectScale: d.detectScale,
        fileName: d.fileName,
        fileKey: d.fileKey,
        pageNum: d.pageNum,
        pageKey: d.pageKey,
        baseRegion: region,
        currentRect: rect,
        mode: 'auto',
        labelIndex: i + 1,
        labelTotal: total,
        splitMode: 'forced',
        splitDebug: {},
        forcedSplit: true,
        forcedSplitMode: mode,
        manualEdited: false
      };
      fileOrder.push(newId);
      renderCardForId(newId);
    }
  }

  // =========================
  // Dataset export/import (Hidden but functional)
  // =========================
  function _sourceKey(d){ return `${d.fileKey}::page:${d.pageNum}`; }
  function exportDatasetJSON() {
    const pages = new Map();
    for (const id of fileOrder) {
      const d = store[id];
      const key = _sourceKey(d);
      if (!pages.has(key)) {
        const meta = pageMetaCache.get(key) || {};
        pages.set(key, {
          key,
          fileName: d.fileName,
          fileKey: d.fileKey,
          pageNum: d.pageNum,
          detectScale: d.detectScale,
          renderW: d.w, renderH: d.h,
          textItemsPx: meta.textItemsPx || [],
          labels: []
        });
      }
      pages.get(key).labels.push({
        id,
        labelIndex: d.labelIndex || 1,
        labelTotal: d.labelTotal || 1,
        mode: d.mode || 'auto',
        manualEdited: !!d.manualEdited,
        rectPx: d.currentRect ? { ...d.currentRect } : null,
        baseRegion: d.baseRegion ? { ...d.baseRegion } : null,
        splitMode: d.splitMode || 'single',
        splitDebug: d.splitDebug || {},
        forcedSplit: !!d.forcedSplit,
        forcedSplitMode: d.forcedSplitMode || null
      });
    }
    const payload = {
      version: "PRAFIA_DATASET_V1",
      createdAt: new Date().toISOString(),
      pages: Array.from(pages.values())
        .map(p => ({ ...p, labels: p.labels.sort((a,b)=> (a.labelIndex||0)-(b.labelIndex||0)) }))
        .sort((a,b)=> (a.fileName+a.pageNum).localeCompare(b.fileName+b.pageNum))
    };
    const blob = new Blob([JSON.stringify(payload, null, 2)], { type: "application/json" });
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = `prafia_label_dataset_${Date.now()}.json`;
    a.click();
    setTimeout(() => URL.revokeObjectURL(a.href), 500);
  }

  async function importDatasetJSON(e){
    const file = e.target.files && e.target.files[0];
    if (!file) return;
    try {
      const txt = await file.text();
      const json = JSON.parse(txt);
      if (!json || !json.pages || !Array.isArray(json.pages)) {
        alert("Invalid JSON dataset");
        return;
      }
      const idx = new Map();
      for (const id of fileOrder) {
        const d = store[id];
        const k = `${d.fileKey}::${d.pageNum}::${d.labelIndex}::${d.labelTotal}`;
        idx.set(k, id);
      }
      let applied = 0;
      for (const p of json.pages) {
        for (const lab of (p.labels || [])) {
          const k = `${p.fileKey}::${p.pageNum}::${lab.labelIndex}::${lab.labelTotal}`;
          const id = idx.get(k);
          if (!id) continue;
          if (lab.rectPx) {
            store[id].currentRect = { ...lab.rectPx };
            store[id].mode = 'manual';
            store[id].manualEdited = true;
            applied++;
            renderResult(id);
          }
        }
      }
      alert(isEn ? `Imported dataset. Applied ${applied} crop boxes.` : `Dataset geïmporteerd. ${applied} crop boxes toegepast.`);
    } catch (err) {
      console.error(err);
      alert("Failed to import JSON dataset (see console).");
    } finally {
      e.target.value = "";
    }
  }

})();